// 搜尋頁 - 搜尋結果

import ListComponent from '../list/ListComponent'; // 列表新聞元件
import ListHint from '../list/ListHint'; // 合作提示
import Pagination from '../layout/Pagination'; // 分頁功能列

const SearchResultList = ({ pageIndex, setPageIndex, pageSize, resultList }) => {
    return (
        <section className="flex-grow space-y-[12px] ulg:space-y-[30px]">
            {/* 結果列表 */}
            {resultList?.map((v, i) => (
                <ListComponent key={v?.id + 'result' + i} info={v} />
            ))}

            {/* 合作提示 */}
            <ListHint />

            {/* 分頁功能列 */}
            <Pagination pageIndex={pageIndex} setPageIndex={setPageIndex} pageSize={pageSize} />
        </section>
    );
};

export default SearchResultList;
